<template>
    <div class="printManagementDialog">
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="800px">
            <div class="dialogContent">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                    <el-form-item label="材料分类" prop="type">
                        <el-cascader
                            v-model="form.type"
                            :options="typeOptions" style="width:100%" @change="selectType"
                            placeholder="请选择材料分类"></el-cascader>
                    </el-form-item>
                    <el-form-item label="材料名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入材料名称"></el-input>
                    </el-form-item>
                    <el-form-item label="工艺类型" prop="processType">
                        <el-radio-group v-model="form.processType">
                            <el-radio v-for="(item,index) in processTypeList" :key="index" :label="item.name"
                                         :name="item.name"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="材料缩略图" prop="thumbnail">
                        <div style="display: flex;">
                            <div v-loading="thumbnailLoading">
                                <el-image
                                    v-if="form.thumbnail"
                                    :src="form.thumbnail" class="thumbnailClass" style="border: solid 1px #ececec;background-color: #f9f9f9;" :preview-src-list="thumbnailList">
                                </el-image>
                            </div>
                            <el-upload
                                action="/service-center/upload/file/single"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload" class="thumbnailClass">
                                <div class="avatar">
                                    <i class="el-icon-plus"></i>
                                </div>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="单价" prop="price">
                        <el-input v-model="form.price" placeholder="请输入材料单价" style="width: 200px;"></el-input>
                        <span style="padding-left: 10px;">元/克</span>
                    </el-form-item>
                    <el-form-item label="工作温度" prop="temperature">
                        <el-input v-model="form.temperature" placeholder="请输入工作温度" style="width: 200px;"></el-input>
                        <span style="padding-left: 10px;">℃</span>
                    </el-form-item>
                    <el-form-item label="尺寸精度" prop="size">
                        <el-input v-model="form.size" placeholder="请输入尺寸精度" style="width: 200px;"></el-input>
                        <span style="padding-left: 10px;">㎜</span>
                    </el-form-item>
                    <el-form-item label="表面质感" prop="texture">
                        <el-input v-model="form.texture" placeholder="请输入表面质感"></el-input>
                    </el-form-item>
                    <el-form-item label="材料特点" prop="characteristic">
                        <el-input v-model="form.characteristic" placeholder="请输入材料特点"></el-input>
                    </el-form-item>
                    <el-form-item label="打印设备" prop="equipment">
                        <el-input v-model="form.equipment" placeholder="请输入打印设备"></el-input>
                    </el-form-item>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="发货周期" prop="startPeriod">
                                <el-input-number v-model="form.startPeriod" :min="1" @change="periodChange"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2">
                          <span style="text-align: center;line-height: 40px;">
                            至
                          </span>
                        </el-col>
                        <el-col :span="10" class="endPeriodClass">
                            <el-form-item prop="endPeriod">
                                <el-input-number v-model="form.endPeriod" :min="1" @change="periodChange"></el-input-number>
                                <span style="padding-left: 10px;">天</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="支持实心/空心" prop="resource">
                        <el-radio-group v-model="form.resource">
                            <el-radio label="实心" name="实心"></el-radio>
                            <el-radio label="空心" name="空心"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否支持后处理" prop="aftertreatment">
                        <el-radio-group v-model="form.aftertreatment">
                            <el-radio label="是" name="是"></el-radio>
                            <el-radio label="否" name="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="支持打印颜色" prop="color">
                        <el-checkbox-group v-model="form.color">
                            <el-checkbox label="红色" name="红色"></el-checkbox>
                            <el-checkbox label="绿色" name="绿色"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="密度" prop="density">
                        <el-input v-model="form.density" placeholder="请输入密度" style="width: 200px;"></el-input>
                        <span style="padding-left: 10px;">g/㎝³</span>
                    </el-form-item>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="出壳比例" prop="startRatio">
                                <el-input-number v-model="form.startRatio" :min="0" :max="100" @change="ratioChange"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2">
                          <span style="text-align: center;line-height: 40px;">
                            至
                          </span>
                        </el-col>
                        <el-col :span="10" class="endPeriodClass">
                            <el-form-item prop="endRatio">
                                <el-input-number v-model="form.endRatio"  :min="0" :max="100"  @change="ratioChange"></el-input-number>
                                <span style="padding-left: 10px;">%</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item prop="sort" label="排序">
                        <el-input-number v-model="form.sort"  :min="1"></el-input-number>
                    </el-form-item>
                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "materialManagementDialog",
        data() {
            return {
                dialogVisible: false,
                title: '',
                form: {
                    type: [],
                    name: '',
                    processType: '',
                    thumbnail: '',
                    price: '',
                    temperature: '',
                    size: '',
                    texture: '',
                    characteristic: '',
                    equipment: '',
                    startPeriod: '1',
                    endPeriod: '1',
                    resource: '',
                    aftertreatment: '',
                    color: [],
                    density: '',
                    startRatio: '0',
                    endRatio: '0',
                    sort: '1'
                },
                rules: {
                    type: [
                        {required: true, message: '请选择材料类型', trigger: 'change'}
                    ],
                    name: [
                        {required: true, message: '请输入材料名称', trigger: 'blur'}
                    ],
                    processType: [
                        {required: true, message: '请选择工艺类型', trigger: 'change'}
                    ],
                    thumbnail: [
                        {required: true, message: '请上传材料缩略图'}
                    ],
                    price:[
                        {required: true, validator: this.validatorNum,trigger: 'blur'}
                    ],
                    temperature:[
                        {required: true, validator: this.validatorNum,trigger: 'blur'}
                    ],
                    size:[
                        {required: true,validator: this.validatorNum,trigger: 'blur'}
                    ],
                    texture: [
                        {required: true, message: '请输入表面质感',trigger: 'blur'}
                    ],
                    characteristic: [
                        {required: true, message: '请输入材料特点', trigger: 'blur'}
                    ],
                    equipment: [
                        {required: true, message: '请输入打印设备',  trigger: 'blur'}
                    ],
                    startPeriod: [
                        {required: true, validator: this.validatorStartPeriod,trigger: 'change'}
                    ],
                    endPeriod: [
                        {required: true, validator: this.validatorEndPeriod,trigger: 'change'}
                    ],
                    resource: [
                        {required: true, message: '请选择支持实心/空心',trigger: 'change'}
                    ],
                    aftertreatment: [
                        {required: true, message: '请选择是否支持后处理',trigger: 'change'}
                    ],
                    color: [
                        {required: true, message: '请选择支持打印颜色',trigger: 'change'}
                    ],
                    density: [
                        {required: true, validator: this.validatorNum,trigger: 'blur'}
                    ],
                    startRatio: [
                        {required: true,validator: this.validatorStartRatio,trigger: 'change'}
                    ],
                    endRatio: [
                        {required: true, validator: this.validatorEndRatio,trigger: 'change'}
                    ],
                    sort: [
                        {required: true, message: '请设置排序',trigger: 'change'}
                    ],
                },
                typeOptions: [
                    {
                        value: '高分子材料',
                        label: '高分子材料',
                        children: [
                            {
                                value: 'PLA',
                                label: 'PLA'
                            },
                            {
                                value: 'ABS',
                                label: 'ABS'
                            },
                            {
                                value: '尼龙',
                                label: '尼龙'
                            },
                            {
                                value: '工程PC塑料',
                                label: '工程PC塑料'
                            },
                            {
                                value: 'TPU材料',
                                label: 'TPU材料'
                            },
                            {
                                value: 'PEEK-聚醚醚酮',
                                label: 'PEEK-聚醚醚酮'
                            },
                            {
                                value: 'ASA',
                                label: 'ASA'
                            },
                            {
                                value: '进囗光敏树脂',
                                label: '进囗光敏树脂'
                            },
                            {
                                value: '透明光敏树脂',
                                label: '透明光敏树脂'
                            }
                        ]
                    },
                    {
                        value: '金属',
                        label: '金属',
                        children: [
                            {
                                value: '模具钢',
                                label: '模具钢'
                            },
                            {
                                value: '高温合金',
                                label: '高温合金'
                            },
                            {
                                value: '铜合金',
                                label: '铜合金'
                            },
                            {
                                value: '钴铬合金',
                                label: '钴铬合金'
                            },
                            {
                                value: '钛合金',
                                label: '钛合金'
                            },
                            {
                                value: '不锈钢',
                                label: '不锈钢'
                            },
                            {
                                value: '铝合金',
                                label: '铝合金'
                            }
                        ]
                    },
                    {
                        value: '无机非金属',
                        label: '无机非金属',
                        children: [
                            {
                                value: '硅砂',
                                label: '硅砂'
                            },
                            {
                                value: '陶粒砂',
                                label: '陶粒砂'
                            },
                            {
                                value: 'SiC',
                                label: 'SiC'
                            },
                            {
                                value: '石墨',
                                label: '石墨'
                            },
                            {
                                value: '陶瓷',
                                label: '陶瓷'
                            }
                        ]
                    }
                ],
                processTypeList: [
                    {
                        name: 'FDM'
                    },
                    {
                        name: 'SLS'
                    },
                    {
                        name: 'SLA'
                    },
                    {
                        name: 'SLM'
                    },
                    {
                        name: '3DP'
                    },
                    {
                        name: 'DLP'
                    }
                ],
                thumbnailLoading: false,
                thumbnailList: []
            }
        },
        methods: {
            init(type) {
                this.dialogVisible = true
                if(this.$refs.ruleForm){
                    this.$refs.ruleForm.resetFields()
                }
                if (type === 'add') {
                    this.title = '新增'
                } else {
                    this.title = '编辑'
                }
            },
            // 选择类型
            selectType(val) {
                if (val.length === 2) {
                    this.form.name = val[1]
                    this.$refs.ruleForm.validateField('name')
                }
            },
            // 缩略图上传
            handleAvatarSuccess(res, file) {
                this.thumbnailList = []
                this.form.thumbnail = res.url
                this.thumbnailList.push(res.url)
                this.thumbnailLoading = false
                this.$refs.ruleForm.validateField('thumbnail')
            },
            beforeAvatarUpload(file) {
                this.thumbnailLoading = true
                const isJPG = file.type.indexOf('image') !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.thumbnailLoading = false
                    this.$message.warning('上传图片只能是图片格式!');
                }
                if (!isLt2M) {
                    this.thumbnailLoading = false
                    this.$message.warning('上传图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            submit(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        alert('submit!');
                    } else {
                        return false;
                    }
                });
            },
            // 表单数字校验
            validatorNum(rule, value, callback){
                if(rule.field === 'price'){
                    if (value === '') {
                        callback(new Error('请输入材料单价'))
                    } else if (!/^\d+(\.\d+)?$/.test(value)) {
                        callback(new Error('请输入数字'))
                    } else {
                        callback()
                    }
                }
                if(rule.field === 'temperature'){
                    if (value === '') {
                        callback(new Error('请输入工作温度'))
                    } else if (!/^\d+(\.\d+)?$/.test(value)) {
                        callback(new Error('请输入数字'))
                    } else {
                        callback()
                    }
                }
                if(rule.field === 'size'){
                    if (value === '') {
                        callback(new Error('请输入尺寸精度'))
                    } else if (!/^\d+(\.\d+)?$/.test(value)) {
                        callback(new Error('请输入数字'))
                    } else {
                        callback()
                    }
                }
                if(rule.field === 'density'){
                    if (value === '') {
                        callback(new Error('请输入密度'))
                    } else if (!/^\d+(\.\d+)?$/.test(value)) {
                        callback(new Error('请输入数字'))
                    } else {
                        callback()
                    }
                }
            },
            validatorStartRatio(rule, value, callback){
                if (value === '') {
                    callback(new Error('请输入出壳比例'))
                } else if (this.form.startRatio > this.form.endRatio) {
                    callback(new Error('开始范围不能大于结束范围'))
                } else {
                    callback()
                }
            },
            validatorEndRatio(rule, value, callback){
                if (value === '') {
                    callback(new Error('请输入出壳比例'))
                } else if (this.form.endRatio < this.form.startRatio) {
                    callback(new Error('结束范围不能小于开始范围'))
                } else {
                    callback()
                }
            },
            ratioChange(){
                this.$refs.ruleForm.validateField('startRatio')
                this.$refs.ruleForm.validateField('endRatio')
            },
            validatorStartPeriod(rule, value, callback){
                if (value === '') {
                    callback(new Error('请选择开始周期'))
                } else if (this.form.startPeriod > this.form.endPeriod) {
                    callback(new Error('开始周期不能大于结束周期'))
                } else {
                    callback()
                }
            },
            validatorEndPeriod(rule, value, callback){
                if (value === '') {
                    callback(new Error('请选择结束周期'))
                } else if (this.form.endPeriod < this.form.startPeriod) {
                    callback(new Error('开始周期不能大于结束周期'))
                } else {
                    callback()
                }
            },
            periodChange(){
                this.$refs.ruleForm.validateField('startPeriod')
                this.$refs.ruleForm.validateField('endPeriod')
            },
        }
    }
</script>

<style scoped lang="less">
    .dialogContent {
        padding: 0 5%;
        /deep/.el-upload-list--picture-card .el-upload-list__item{
            width: 80px;
            height: 80px;
        }
        /deep/.el-upload--picture-card{
            width: 80px;
            height: 80px;
            line-height: 80px;
        }
        /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail{
            width: 80px;
            height: 80px;
        }
        .thumbnailClass{
            width: 80px;
            height: 80px;
            margin-right: 20px;
            .avatar{
                width: 80px;
                height: 80px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 80px;
                font-size: 24px;
            }
        }
        .endPeriodClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
            }
        }
        .submitButtonClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
                text-align: center;
                button{
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 6px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/commodity/printManagement/materialManagementDialog.vue